import React from 'react';

import { connect } from 'react-redux';

import { LegacyAnalyticsInterface } from '@nerdwallet/calculator-onboarding-modal';
import { Select } from '@nerdwallet/currency';

import { RENT_VS_BUY } from '../../../../lib/analytics-constants';
import {
  RentVsBuyInput,
  INPUT_TRACKING_TYPES,
  inputOnChange,
  BedrockInterface,
} from '../../../../lib/utils';
import { loanTerms as LoanTermOptions } from '../shared/constants';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const LoanTermInput: React.FC<RentVsBuyInput> = ({
  value,
  errorMessage,
  dispatch,
  analytics,
  label = '',
  className = '',
  tooltip = '',
  fullWidth,
}) => {
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy: LegacyAnalyticsInterface;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        inputType: INPUT_TRACKING_TYPES.RANGE,
      };
    }

    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'loanTerm',
      calculator: RENT_VS_BUY,
      inputType: 'number',
    });
  };

  return (
    <Select
      options={LoanTermOptions}
      value={value}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      label={label}
      className={className}
      tooltip={tooltip}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  value: state?.rentvsbuyCalculator?.inputs?.loanTerm,
  errorMessage: state?.validations?.loanTerm?.[0],
});

export default connect(mapStateToProps)(LoanTermInput);
